import {
  ProviderFilters,
  SearchFilter,
} from '../../../WbGeneralPurposeEntityPicker';
import { WbResponsiveTableToolbar } from '../../../WbTable/WbResponsiveTableToolbar';
import useGroupContext from './GroupProvider';

export interface GroupsFilters extends ProviderFilters {}

enum AvailableGroupsFilters {
  search = 'search',
}

export const GroupsFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    useGroupContext();

  const filterElement = (key: string) => {
    if (key === AvailableGroupsFilters.search)
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    return <></>;
  };

  return (
    <WbResponsiveTableToolbar onClear={resetFilters} marginBottom>
      <WbResponsiveTableToolbar.Filters>
        {(templateKind?.userFilters ?? ['search']).map(filter =>
          filterElement(filter),
        )}
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
